import React, { memo, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box } from '@mui/material';
import Paper from '@mui/material/Paper';
import useDeviceDetect from '../Detect/useDeviceDetect ';
import ItemLedgerCard from './ItemLedgerCard';
import ItemLedgerTable from './ItemLedgerTable';
import PopupDialogTitle from '../Dialog/PopupDialogTitle';
import Calculation from '../../utility/Calculations';
import { triggerLoader } from '../../redux/reducers/LoaderTrigger';
import { useDispatch } from 'react-redux';

//FUNCTION
const ItemLedgerPopup = memo(({ openItemLedger, handleItemLedgerClose, itemLedger, selectedItem, itemLedgerLoading }) => {
    const { isMobile } = useDeviceDetect();
    const dispatch = useDispatch();
    const itemRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => itemRef.current,
        documentTitle: 'Item Ledger',
    });

    const handleDownload = () => {
        try {
            dispatch(triggerLoader());
            const input = itemRef.current;

            html2canvas(input, { scale: 1 }) // Adjust the scale to reduce resolution (e.g., 1 for lower resolution)
                .then(canvas => {
                    const imgData = canvas.toDataURL('image/jpeg', 0.75); // Use 'image/jpeg' and reduce quality (0.75 is 75% quality)
                    const pdf = new jsPDF();
                    const imgProps = pdf.getImageProperties(imgData);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

                    pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight); // Use 'JPEG' instead of 'PNG'
                    const name = selectedItem.item_name ?? 'ItemLedger';
                    const date = Calculation.GetCurrentDateString();
                    const pdfName = name + '_' + date + '.pdf';
                    setTimeout(() => {
                        pdf.save(pdfName);
                        dispatch(triggerLoader());
                    }, 5000);
                })
                .catch(error => {
                    console.error('Error generating PDF: ', error);
                    dispatch(triggerLoader()); // Stop loader if there's an error
                });
        }
        catch (e) {
            console.log(e);
            dispatch(triggerLoader()); // Stop loader if there's an error in try block
        }
    };

    return (
        <>
            <Dialog
                open={openItemLedger}
                onClose={handleItemLedgerClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={false}
                PaperProps={{
                    sx: {
                        width: '80%',
                        height: '80%',
                    },
                }}
            >
                <PopupDialogTitle handleDownload={handleDownload} handlePrint={handlePrint} handleClose={handleItemLedgerClose} />
                <DialogContent>
                    {
                        isMobile ?
                            <Box component={Paper} sx={{ padding: '16px', backgroundColor: '#fff', overflowY: 'auto', maxHeight: '80vh', border: 'none' }} ref={itemRef}>
                                {itemLedger.length > 0 ? (
                                    <ItemLedgerCard itemLedger={itemLedger} selectedItem={selectedItem} itemLedgerLoading={itemLedgerLoading} />
                                ) : (
                                    ''
                                )}
                            </Box>
                            :
                            <Box component={Paper} sx={{ padding: '16px', backgroundColor: '#fff', overflowY: 'auto', maxHeight: '80vh', border: 'none' }} ref={itemRef}>
                                <ItemLedgerTable itemLedger={itemLedger} selectedItem={selectedItem} itemLedgerLoading={itemLedgerLoading} />
                            </Box>
                    }
                </DialogContent>
            </Dialog>
        </>
    )
});

export default memo(ItemLedgerPopup);
